
import React from "react";
import { Search, Users } from "lucide-react";
import Pagination from "../Common/Pagination";
import "../../Styles/UsersTable.css";

const UsersTable = ({ 
  users, 
  currentPage, 
  totalPages, 
  searchTerm, 
  onSearchChange, 
  onPageChange 
}) => {
  const renderEmptyState = () => (
    <div className="cd-empty-state">
      {searchTerm ? (
        <>
          <Search size={40} color="#9ca3af" />
          <p>No users match your search criteria</p>
        </>
      ) : (
        <>
          <Users size={40} color="#9ca3af" />
          <p>No users available for this company</p>
        </>
      )}
    </div>
  );

  return (
    <div className="cd-table-card">
      <div className="cd-table-header">
        <h2 className="cd-table-title">Company Users</h2>
        <div className="cd-search-container">
          <Search size={18} className="cd-search-icon" />
          <input
            type="text"
            placeholder="Search users..."
            className="cd-search-input"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
      </div>

      {users.length > 0 ? (
        <>
          <div className="cd-table-container">
            <table className="cd-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Employee ID</th>
                  <th>Phone Number</th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.id} className="cd-table-row">
                    <td className="cd-table-cell cd-name-cell">{user.name || "N/A"}</td>
                    <td className="cd-table-cell">{user.email || "N/A"}</td>
                    <td className="cd-table-cell">{user.employeeId || "N/A"}</td>
                    <td className="cd-table-cell">{user.phoneNumber || "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {/* Pagination */}
          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={onPageChange}
              className="cd-pagination"
            />
          )}
        </>
      ) : renderEmptyState()}
    </div>
  );
};

export default UsersTable;
